<template>
  <div class="card">
    <div class="badge" :class="badgeClass">
      <span class="badge-text">{{ badgeLevel }}</span>
    </div>
    <EmployeeCard
      :firstName="first_name"
      :lastName="last_name"
      :position="title"
      :photoUrl="avatar"
      :showAvailability="false"
      :isHoverEnabled="false"
    />
  </div>
</template>

<script setup>
import { computed } from "vue";
import EmployeeCard from "@components/organizations/employees/EmployeeCard/EmployeeCard.vue";

const props = defineProps({
  badgeLevel: {
    type: String,
    required: true,
  },
  avatar: {
    type: String,
    default: "",
  },
  first_name: {
    type: String,
    required: true,
  },
  last_name: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  isHoverEnabled: {
    type: Boolean,
    default: false,
  },
});

const badgeClass = computed(() => ({
  "badge-coach": props.badgeLevel === "Coach",
  "badge-master": props.badgeLevel === "Master",
}));
</script>

<style scoped>
.card {
  display: flex;
  align-items: center;
  background-color: #d9d9d9;
  border-radius: 5px;
  position: relative;
  gap: 12px;
  width: fit-content;
  padding-right: 12px;
}
.badge-text {
  writing-mode: vertical-rl;
  transform: rotate(180deg);
}

.badge {
  font-weight: 600;
  padding: 5.5px 3px;
  border-radius: 5px 0 0 5px;
  text-align: center;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.badge-coach {
  background-color: #00f0ff;
  color: #101828;
}

.badge-master {
  background-color: #00a3ff;
  color: white;
}
</style>
